import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { H4 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { CaretLeft } from '@liveauctioneers/hammer-ui-core/icons';
import * as React from 'react';
import { ReactElement } from 'react';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

import { getCategoryFacetLink } from '@/utils/urls';

export type TaxonomyParentProps = {
    categoryId: string;
    parentSelected: (id: number, categoryId: string) => void;
    parents: any[];
    queryParams: any;
    showLandingPageLinks: boolean;
};

const TaxonomyParent = ({
    categoryId,
    parents,
    parentSelected,
    queryParams,
    showLandingPageLinks,
}: TaxonomyParentProps): ReactElement => {
    if (parents?.length > 0) {
        return (
            <>
                {parents.map((parent, index) => {
                    const icon = (
                        <CaretLeft
                            className="-mt-[2px] inline-block"
                            size="xs"
                        />
                    );
                    if (parents.length > index) {
                        return (
                            <StyledOptionParent key={parent.id}>
                                {parent.landingPageUrl && showLandingPageLinks ? (
                                    <StyledLink
                                        route
                                        to={getCategoryFacetLink(parent.landingPageUrl, queryParams)}
                                    >
                                        {icon} {parent.name}
                                    </StyledLink>
                                ) : (
                                    <a onClick={() => parentSelected(parent.id, categoryId)}>
                                        {icon} {parent.name}
                                    </a>
                                )}
                            </StyledOptionParent>
                        );
                    }

                    return <StyledSelected key={parent.id}>{parent.name}</StyledSelected>;
                })}
            </>
        );
    }

    return null;
};

export default React.memo<TaxonomyParentProps>(TaxonomyParent, isEqual);

const StyledOptionParent = styled.div`
    a {
        font-size: 15px;
        margin: 0 0 10px;
        text-decoration: none;
    }

    &:last-of-type a {
        margin-bottom: 0;
    }
`;

const StyledSelected = styled(H4)`
    margin: 0;
    font-family: ${({ theme }) => theme.typography.fontPrimaryStrong};
    cursor: pointer;
    color: ${({ theme }) => theme.colors.black};
`;

const StyledLink = styled(Link)`
    text-decoration: none;
`;
